<script>
import ShiftInfoComponent from '@/components/ShiftInfoComponent'
import RightLayout from '../layouts/rightLayout'
import {DateUtil} from '@/utils/date.js'

export default {
  components: {ShiftInfoComponent, RightLayout},
  data () {
    return {
      // 便情報
      shiftBasicModel: {
        // 便Id
        shiftId: '',
        // 便名称（update）
        title: '',
        // ルートID(有人时不可变，无人时可以变（update）)
        routeId: '',
        // ルートName
        routeName: '',
        // ドライバーUID  （update） 其中driverName和driverNameKana也都可以得到具体传不传看登录画面
        driverUid: '',
        // 車両ID  （update）
        vehicleId: '',
        // 運行日  （update）（可能需要分别单独传年月日）
        moveShiftTime: '',
        // 行帰フラグ  （update）
        shiftFlag: '0',
        // 出発予定時台  (对应shiftFlag: '0'  ？？？？？？写下面还是上面)
        startEstimateTimeSlot: '',
        // 到着予定時台 (对应shiftFlag: '1'  ？？？？？？？)
        arriveEstimateTimeSlot: '',
        // 利用料金  （update）
        shiftCost: '',
        // 予約者数
        reserveNumber: 0,
        // イベントID
        eventId: '',
        // フリガナ
        driverKanaName: '',
        // ドライバー
        driverName: '',
        // 車両
        vehicleName: '',
        // 車両定員人数
        passengerNumber: '',
        // 便タイプ
        shiftType: '',
        shiftMovementStatus: 3,
        // 地区ID
        areaId: null,
        // 地区名
        areaName: '',
        businessStatus: 3,
        // コメント
        comment: '',
      },
      // 便経由地情報(如果分开请求后台时，别忘记添加shiftId)
      shiftPasspoint: {
        // 便Id
        shiftId: '',
        // 経由地番号
        routeNo: '',
        // 順番  （update，只是把乘车人顺番交换以及出发、到着予定或到着日时更换）
        sortNo: '',
        // 出発予定日時 （update）
        startEstimateTime: '',
        // 到着予定日時 （update）
        arriveEstimateTime: '',
        // 是否停车标志：true为停车，false为不停车
        stopFlag: false,
        // 経由地タイプ
        routeType: '',
        // 自定义経由地类型：S G1-Gn G 1-n
        index: '',
        // 経由地名称或者人名
        name: '',
        // 经度
        stationLat: 0.00,
        // 纬度
        stationLng: 0.00

      },
      //  便経由地情報数组(如果分开请求后台时，别忘记添加shiftId)(可以放到最小组件里)
      // shiftPasspoints: [],

      // 運行日：年
      moveShiftTimeYear: 0,
      // 運行日：月
      moveShiftTimeMonth: 0,
      // 運行日：日
      moveShiftTimeDay: 0,

      // 区域外対応
      // 便情報
      shiftModel: {
        frontId: '0000',
        shiftEvent: null,
        shiftBasic: {
          // 便Id
          shiftId: '',
          // 便名称（update）
          title: '',
          // ルートID(有人时不可变，无人时可以变（update）)
          routeId: '',
          // ルートName
          routeName: '',
          // ドライバーUID  （update） 其中driverName和driverNameKana也都可以得到具体传不传看登录画面
          driverUid: '',
          // 車両ID  （update）
          vehicleId: '',
          // 運行日  （update）（可能需要分别单独传年月日）
          moveShiftTime: '',
          // 行帰フラグ  （update）
          shiftFlag: '0',
          // 出発予定時台  (对应shiftFlag: '0'  ？？？？？？写下面还是上面)
          startEstimateTimeSlot: '',
          // 到着予定時台 (对应shiftFlag: '1'  ？？？？？？？)
          arriveEstimateTimeSlot: '',
          // 利用料金  （update）
          shiftCost: '',
          // 予約者数
          reserveNumber: 0,
          // イベントID
          eventId: '',
          // フリガナ
          driverKanaName: '',
          // ドライバー
          driverName: '',
          // 車両
          vehicleName: '',
          // 車両定員人数
          passengerNumber: '',
          // 便タイプ
          shiftType: '',
          shiftMovementStatus: 3,
          // 地区ID
          areaId: null,
          // 地区名
          areaName: '',
          businessStatus: 3,
          // コメント
          comment: '',
        },
        // shiftPasspoint
        shiftPasspointList: [],
        functionFlag: '1',
        loopDateList: null,
        // shiftReservationInfos
        shiftReservationInfoList: [],
        // 時刻リスト
        hourList: [],
        minuteList: [],
        timeList: [],
        shiftTimeInfoList: [],
        // ドライバー情報
        shiftTimeInfoListByDriverUid: [],
        // 車両情報
        selectedVehicle: [],
        // ドライバーアプリ使用有無 1:ドライバーアプリ使用 2:未使用
        routeType: '',
        // ルート選択フラグ
        routeSelected: false,
        // 停留所一覧
        stationList: [{
          routeId: '',
          routeName: '',
          stationName: '',
        }],
      },
      shiftList: [],
      shiftConnectList: [],
      isLoading: true,
      lockedByReserve: false,
      lockedByAddShift: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      // 清除shiftReservationInfoList
      sessionStorage.removeItem('shiftReservationInfoList')
      let shiftDetail = {}
      if (this.$route.query.editorIsCancel === 'true' || this.$route.query.editorIsCancel === true) {
      // event取消前修改的信息
        // this.isCancel = true
        shiftDetail = JSON.parse(sessionStorage.getItem('eventShiftDetail'))
      } else {
        shiftDetail = JSON.parse(sessionStorage.getItem('shiftDetail'))
      }
      console.log("Editor created")
      console.log("shiftDetail")
      console.log(shiftDetail)
      let shiftInfo = shiftDetail.shiftInfo
      this.shiftBasicModel.shiftId = shiftInfo.shiftId
      this.shiftBasicModel.title = shiftInfo.title
      this.shiftBasicModel.routeId = shiftInfo.routeId
      this.shiftBasicModel.driverUid = shiftInfo.driveUid
      this.shiftBasicModel.vehicleId = shiftInfo.vehicleId
      console.log("shiftInfo.moveShiftTime")
      console.log(shiftInfo.moveShiftTime)
      this.shiftBasicModel.moveShiftTime = DateUtil.getYearMonthDay(shiftInfo.moveShiftTime)
      this.shiftBasicModel.shiftFlag = String(shiftInfo.shiftFlag)
      if (shiftInfo.shiftFlag === '0') {
        this.shiftBasicModel.startEstimateTimeSlot = shiftInfo.startEstimateTimeSlot
      } else {
        this.shiftBasicModel.arriveEstimateTimeSlot = shiftInfo.arriveEstimateTimeSlot
      }
      this.shiftBasicModel.shiftCost = shiftInfo.shiftCost
      if (shiftInfo.shiftReservationInfos.length > 0) {
        // this.shiftBasicModel.reserveNumber = shiftInfo.shiftReservationInfos.length
        this.shiftBasicModel.reserveNumber = shiftInfo.reserveNumber
      } else {
        this.shiftBasicModel.reserveNumber = 0
      }
      // alert('-' + this.shiftBasicModel.routeId + '--' + shiftInfo.shiftReservationInfos.length + ' --' + this.shiftBasicModel.reserveNumber)
      this.shiftBasicModel.eventId = shiftInfo.eventId
      this.shiftBasicModel.driverKanaName = shiftInfo.driverNameKana
      this.shiftBasicModel.driverName = shiftInfo.driverName
      this.shiftBasicModel.vehicleName = shiftInfo.vehicleName
      this.shiftBasicModel.passengerNumber = shiftInfo.passengerNumber
      this.shiftBasicModel.shiftType = shiftInfo.shiftType
      this.getYearMonthDay(shiftInfo.moveShiftTime)
      this.shiftBasicModel.shiftMovementStatus = shiftInfo.shiftMovementStatus
      // 获取route-name
      // if (this.shiftBasicModel.reserveNumber > 0) {
      //   if (this.shiftBasicModel.routeId !== null && this.shiftBasicModel.routeId !== '') {
      //     this.$axios.get('shift/queryRouteNameById', {params: {routeId: this.shiftBasicModel.routeId}})
      //       .then(response => {
      //         this.shiftBasicModel.routeName = response.data.routeName
      //       })
      //       .catch(function (error) {
      //         console.log(error)
      //       })
      //   }
      // }
      this.shiftBasicModel.routeName = JSON.parse(sessionStorage.getItem('routeName'))
      this.shiftBasicModel.areaId = shiftInfo.areaId
      this.shiftBasicModel.areaName = shiftInfo.areaName
      this.shiftBasicModel.businessStatus = shiftInfo.businessStatus
      this.shiftBasicModel.comment = shiftInfo.comment

      console.log("this.shiftBasicModel")
      console.log(this.shiftBasicModel)
      // 区域外対応
      // 接続便グループ
      let sameParentShiftList = []
      // 探索対象
      let targetShiftId = ''
      if(shiftInfo.parentShiftId === '' || shiftInfo.parentShiftId === null){
        // 区域内
        sameParentShiftList.push(shiftInfo.shiftId)
        targetShiftId = shiftInfo.shiftId
      }else{
        // 区域外
        sameParentShiftList.push(shiftInfo.parentShiftId)
        targetShiftId = shiftInfo.parentShiftId
      }

      // 便一覧からparentShiftIdが同じ便情報をすべて取得
      this.$axios.get('shift/queryShiftInfoListByParentShiftId', {params: {parentShiftId: targetShiftId}}).then(response => {
        console.log("response")
        console.log(response)
        let shiftInfoList

        shiftInfoList = response.data.shiftInfoList
        for (let shiftInfoTemp of shiftInfoList) {
          if (shiftInfoTemp.parentShiftId === targetShiftId) {
            sameParentShiftList.push(shiftInfoTemp.shiftId)
          }
        }

        console.log("sameParentShiftList")
        console.log(sameParentShiftList)
        let shiftDetailList = []
        for(let i = 0; i < sameParentShiftList.length; i++){
          for (let shiftInfoTemp of shiftInfoList) {
            if(shiftInfoTemp.shiftId == sameParentShiftList[i]){
              let shiftModelTemp = {
                  frontId: '0000',
                  shiftEvent: null,
                  shiftBasic: {},
                                // shiftPasspoint
                  shiftPasspointList: [],
                  functionFlag: '1',
                  loopDateList: null,
                  // shiftReservationInfos
                  shiftReservationInfoList: [],
                  // 時刻リスト
                  hourList: [],
                  minuteList: [],
                  timeList: [],
                  shiftTimeInfoList: [],
                  // ドライバー情報
                  shiftTimeInfoListByDriverUid: [],
                  // 車両情報
                  selectedVehicle: [],
                  // ドライバーアプリ使用有無 1:ドライバーアプリ使用 2:未使用
                  routeType: '',
                  // ルート選択フラグ
                  routeSelected: false,
                  // 停留所一覧
                  stationList: [{
                    routeId: '',
                    routeName: '',
                    stationName: '',
                  }],
                  transportKind: 0,
                  parentShiftId: '',
                  }
              // let shiftModelTemp
              // shiftModelTemp = this.shiftModel
              shiftModelTemp.shiftBasic.shiftId = shiftInfoTemp.shiftId
              shiftModelTemp.shiftBasic.title = shiftInfoTemp.title
              shiftModelTemp.shiftBasic.routeId = shiftInfoTemp.routeId
              shiftModelTemp.shiftBasic.driverUid = shiftInfoTemp.driveUid
              shiftModelTemp.shiftBasic.vehicleId = shiftInfoTemp.vehicleId
              console.log("shiftInfoTemp.moveShiftTime")
              console.log(shiftInfoTemp.moveShiftTime)
              shiftModelTemp.shiftBasic.moveShiftTime = shiftInfoTemp.moveShiftTime
              shiftModelTemp.shiftBasic.shiftFlag = String(shiftInfoTemp.shiftFlag)
              if (shiftInfoTemp.shiftFlag === '0') {
                shiftModelTemp.shiftBasic.startEstimateTimeSlot = shiftInfoTemp.startEstimateTimeSlot
              } else {
                shiftModelTemp.shiftBasic.arriveEstimateTimeSlot = shiftInfoTemp.arriveEstimateTimeSlot
              }
              shiftModelTemp.shiftBasic.shiftCost = shiftInfoTemp.shiftCost
              if (shiftInfoTemp.shiftReservationInfos.length > 0) {
                shiftModelTemp.shiftBasic.reserveNumber = shiftInfoTemp.reserveNumber
              } else {
                shiftModelTemp.shiftBasic.reserveNumber = 0
              }

              shiftModelTemp.shiftBasic.eventId = shiftInfoTemp.eventId
              shiftModelTemp.shiftBasic.driverKanaName = shiftInfoTemp.driverNameKana
              shiftModelTemp.shiftBasic.driverName = shiftInfoTemp.driverName
              shiftModelTemp.shiftBasic.vehicleName = shiftInfoTemp.vehicleName
              shiftModelTemp.shiftBasic.passengerNumber = shiftInfoTemp.passengerNumber
              shiftModelTemp.shiftBasic.shiftType = shiftInfoTemp.shiftType
              // this.getYearMonthDay(shiftInfoTemp.moveShiftTime)
              shiftModelTemp.shiftBasic.shiftMovementStatus = shiftInfoTemp.shiftMovementStatus

              shiftModelTemp.shiftBasic.routeName = JSON.parse(sessionStorage.getItem('routeName'))
              shiftModelTemp.shiftBasic.areaId = shiftInfoTemp.areaId
              shiftModelTemp.shiftBasic.areaName = shiftInfoTemp.areaName
              shiftModelTemp.shiftBasic.businessStatus = shiftInfoTemp.businessStatus

              shiftModelTemp.shiftBasic.transportKind = shiftInfoTemp.transportKind
              shiftModelTemp.shiftBasic.parentShiftId = shiftInfoTemp.parentShiftId
              shiftModelTemp.shiftBasic.comment = shiftInfoTemp.comment
              this.shiftList.push(shiftModelTemp)

              let shiftDetail = {
                shiftInfo: shiftInfoTemp,
                shiftPasspoints: shiftInfoTemp.shiftPasspoints
              }
              for(let index = 0; index < shiftDetail.shiftPasspoints.length; index++){
                shiftDetail.shiftPasspoints[index].estimateTime = (shiftDetail.shiftPasspoints[index].arriveEstimateTime !== null)&&(shiftDetail.shiftPasspoints[index].arriveEstimateTime !== '') ? shiftDetail.shiftPasspoints[index].arriveEstimateTime : shiftDetail.shiftPasspoints[index].startEstimateTime
                console.log("shiftDetail.shiftPasspoints[index].estimateTime")
                console.log(shiftDetail.shiftPasspoints)
                console.log(shiftDetail.shiftPasspoints[index].estimateTime)
                shiftDetail.shiftPasspoints[index].name = shiftDetail.shiftPasspoints[index].stationName
                shiftDetail.shiftPasspoints[index].officeFlag = shiftDetail.shiftPasspoints[index].officeFlag
                
                if(index === 0){
                  shiftDetail.shiftPasspoints[index].index = 'S'
                }else if(index === shiftDetail.shiftPasspoints.length -1){
                  shiftDetail.shiftPasspoints[index].index = 'G'
                }else{
                  shiftDetail.shiftPasspoints[index].index = index
                }
              }
              shiftDetailList.push(shiftDetail)
              console.log("shiftDetailList")
              console.log(shiftDetailList)
            }
          }
        }
        sessionStorage.setItem('shiftDetailList', JSON.stringify({shiftDetailList: shiftDetailList}))
          
        if (this.$route.query.editorIsCancel === 'true' || this.$route.query.editorIsCancel === true) {
          console.log("イベントキャンセルからshiftListをセット")
          this.shiftList = JSON.parse(sessionStorage.getItem('shiftList'))
          this.shiftList[0].shiftBasic.shiftType = '1'
        }

        console.log("this.shiftList")
        console.log(this.shiftList)

        // 予約者がいる場合、便の追加・削除と接続の編集をロックする
        for(let i = 0; i < this.shiftList.length; i++){
          if(this.shiftList[i].shiftBasic.reserveNumber > 0){
            this.lockedByReserve = true
          }
        }
        // 増便された便の場合、便の追加を禁止する
        this.$axios.get('shift/isEnableShiftConnect', {params: {shiftId: this.shiftList[0].shiftBasic.shiftId}}).then(response => {
          console.log("isEnableShiftConnect")
          console.log(response.data)
          this.lockedByAddShift = !response.data.shiftConnectFlg
        })

        this.getShiftConnectList()
      }).catch(error => {
        console.log(error)
      })
      
    },
    getYearMonthDay (date) {
      if (date !== null && date !== '') {
        this.moveShiftTimeYear = parseInt(date.substr(0, 4))
        date = date.replace(' 年 ', '年').replace(' 月 ', '月').replace(' 日 ', '日')
        let yearIndex = date.indexOf('年')
        let monthIndex = date.indexOf('月')
        let dayIndex = date.indexOf('日')
        let month = date.substring(yearIndex + 1, monthIndex)
        let day = date.substring(monthIndex + 1, dayIndex)
        this.moveShiftTimeMonth = parseInt(month)
        this.moveShiftTimeDay = parseInt(day)
      }
    },
    getShiftConnectList (){
      console.log("getShiftConnectList")
      // this.$axios.get('shift/queryShiftConnectList', {params: {parentId: this.shiftList[0].shiftBasic.shiftId}}).then(response => {
      this.$axios.get('shift/queryShiftConnectListForShiftEditor', {params: {parentId: this.shiftList[0].shiftBasic.shiftId}}).then(response => {
        console.log(response.data)
        console.log(this.shiftConnectList)
        for(let i=0; i < response.data.shiftConnectList.length; i++){
          let shiftConnectTemp = {
              frontShiftConnect: {
                shiftId: '0000',
                connectSourceShiftId: '0000',
                stationId: '',
                connectSourceStationId: '',
                stationTime: '',
                connectSourceStationTime: '',
                stationUseTime: 0,
                errorMessage: '',
                timeError: 0
              },
              shiftConnect: {
                shiftId: '',
                connectSourceShiftId: '',
                stationId: '',
                connectSourceStationId: '',
                stationUseTime: 0
              },
            }
          console.log("i")
          console.log(i)
          // console.log("response.data.shiftConnectList[i]")
          // console.log(response.data.shiftConnectList[i])
          // console.log("this.shiftConnectList[i]")
          // console.log(this.shiftConnectList[i])
          shiftConnectTemp.frontShiftConnect = response.data.shiftConnectList[i]
          shiftConnectTemp.shiftConnect = response.data.shiftConnectList[i]
          this.shiftConnectList.push(shiftConnectTemp)
        }

        if (this.$route.query.editorIsCancel === 'true' || this.$route.query.editorIsCancel === true) {
          console.log("イベントキャンセルからshiftConnectListをセット")
          this.shiftConnectList = JSON.parse(sessionStorage.getItem('shiftConnectList'))
        }
        console.log("this.isLoading = false")
        this.isLoading = false
      })
    },

  }
}
</script>

<template>
<right-layout>
<Shift-info-component
    :title="'便を編集'"
    :btnName="'保存'"
    :functionFlag="'1'"
    :shiftList=shiftList
    :shiftConnectList=shiftConnectList
    :shiftBasicModel=shiftBasicModel
    :moveShiftTimeYear=moveShiftTimeYear
    :moveShiftTimeMonth=moveShiftTimeMonth
    :moveShiftTimeDay=moveShiftTimeDay
    :isLoading=isLoading
    :lockedByReserve=lockedByReserve
    :lockedByAddShift=lockedByAddShift
    ></Shift-info-component>
</right-layout>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/router/views/ShiftEditor.vue